import * as TABLE from 'constant/action/table'
import { createAction } from 'redux-actions'

const updateColumns = createAction(TABLE.UPDATE_COLUMNS)
const updateShownColumns = createAction(TABLE.UPDATE_SHOWN_COLUMNS)
const updateHiddenColumns = createAction(TABLE.UPDATE_HIDDEN_COLUMNS)
const resetColumns = createAction(TABLE.RESET_COLUMNS)
const updateShowSubTable = createAction(TABLE.UPDATE_SHOW_SUB_TABLE)

export const updateTableColumns = (table, key) => (dispatch, getState) => {
  const state = getState()
  const columns = { ...state.table.columns }
  const shownColumns = { ...state.table.shownColumns }
  const hiddenColumns = { ...state.table.hiddenColumns }

  columns[table] = columns[table].map((column) => {
    if (column.key === key) {
      if (column.show) {
        hiddenColumns[table][key] = shownColumns[table][key]
        shownColumns[table][key] = {}
      } else {
        shownColumns[table][key] = hiddenColumns[table][key]
        hiddenColumns[table][key] = {}
      }

      column.show = !column.show
    }
    return column
  })

  dispatch(updateShownColumns(shownColumns))
  dispatch(updateHiddenColumns(hiddenColumns))
  dispatch(updateColumns(columns))
}

export const resetTable = (table) => (dispatch, getState) => dispatch(resetColumns(table))

export const showSubTable = (subCategories, category) => (dispatch, getState) => {
  dispatch(updateShowSubTable({ category, show: true, sub_categories: subCategories }))
}

export const closeSubTable = () => (dispatch, getState) => dispatch(updateShowSubTable({ category: {}, show: false, sub_categories: [] }))
